
// import { Injectable } from '@angular/core';

// @Injectable({  
//   providedIn: 'root'  
// })  

// export class AuthService {  
//   private Email = 'admin@noritzequip.com';  
//   private Password = 'admin';  
//   isloggedin = false;  
//   constructor() {}  
//   checkLogValues(value: any): boolean {  
//       if (this.Email === value.Email && this.Password === value.Password) {   
//           return true;  
//       } else {
//           return false;
//       }  
//   }  
// }  


import { Injectable } from '@angular/core';
import { ToastyService } from 'ng2-toasty';

@Injectable({  
  providedIn: 'root'  
})  

export class AuthService {  
  private Email = 'admin@noritzequip.com';  
  private Password = 'admin';  
  isloggedin = false;  
  constructor() {}  
  checkLogValues(value: any): boolean {  
      if (this.Email === value.Email && this.Password === value.Password) {  
          // alert('Login valid');  
          return true;  
      } else {
          // alert('please enter valid data');
          return false;
      }  
  }  
}  
